import React from 'react';

import styles from './allocatorProfileSectionStyles';

import AllocatorProfileSectionHeader from './AllocatorProfileSectionHeader/allocatorProfileSectionHeader';
import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import AllocatorProfileFormModalContainer from 'buyside/components/container/AllocatorProfileShow/AllocatorProfileFormModalContainer';
import AlertStatic from 'buyside/components/presentation/AlertStatic/alertStatic';

import PencilIcon from 'buyside/svgs/pencil.svg';

import { onboardingUrl } from 'buyside/util/urlHelper';

class AllocatorProfileSection extends React.Component {
  constructor() {
    super();
    this.state = { editModalOpen: false };
    this.openEditModal = this.openEditModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openEditModal() {
    this.setState({ editModalOpen: true });
  }

  closeModal() {
    this.setState({
      editModalOpen: false,
      serverError: false
    });
  }

  render() {
    const {
      section,
      isAdmin,
      allocatorProfile,
      icon,
      title,
      sectionEmpty,
      emptyText,
      component: Component,
      editForm,
      editFormBoxText,
      validationSchema,
      updateAllocatorProfile
    } = this.props;
    const updateSection = ({ allocatorProfile }) =>
      updateAllocatorProfile({ allocatorProfile, section });
    const isInvestmentPreferences = section === 'investment_preferences';
    const sectionVisibility = section === 'investment_criteria' ? 'admin' : null;

    return (
      <div>
        <AllocatorProfileSectionHeader
          icon={icon}
          title={title}
          sectionVisibility={sectionVisibility}
          openEditModal={editForm && this.openEditModal}
          isAdmin={isAdmin}
        />
        {isAdmin && editForm && (
          <AllocatorProfileFormModalContainer
            isOpen={this.state.editModalOpen}
            closeModal={this.closeModal}
            modalId={`form_${section}`}
            icon={icon}
            title={title}
            alertText={editFormBoxText}
            form={editForm}
            allocatorProfile={allocatorProfile}
            validationSchema={validationSchema}
            update={updateSection}
          />
        )}
        {isAdmin && isInvestmentPreferences && (
          <span>
            <Button
              className={styles.updateInvestmentPreferences}
              text="Update investment preferences here."
              type={BUTTON_TYPES.LINK}
              icon={PencilIcon}
              url={onboardingUrl()}
            />
            &nbsp;Preferences are used to recommend funds.
          </span>
        )}
        {sectionEmpty && !isInvestmentPreferences && <AlertStatic>{emptyText}</AlertStatic>}
        {!sectionEmpty && <Component allocatorProfile={allocatorProfile} isAdmin={isAdmin} />}
      </div>
    );
  }
}

export default AllocatorProfileSection;
